import { render, staticRenderFns } from "./qiyecx.vue?vue&type=template&id=ce2f056c&scoped=true"
import script from "./qiyecx.vue?vue&type=script&lang=js"
export * from "./qiyecx.vue?vue&type=script&lang=js"
import style0 from "./qiyecx.vue?vue&type=style&index=0&id=ce2f056c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f056c",
  null
  
)

export default component.exports